 
import React, { useRef } from "react";
import Swal from "sweetalert2";
import Loader from "../../../assets/images/loader.gif";

const Form = () => {
  const form = useRef();

  const showLoader = () => {
    const loader = document.createElement("div");
    loader.className = "loader-wrp";

    const figure = document.createElement("figure");
    const img = document.createElement("img");

    img.src = Loader;
    img.alt = "Loader";

    figure.appendChild(img);
    loader.appendChild(figure);
    document.body.appendChild(loader);
  };

  const hideLoader = () => {
    const loader = document.querySelector(".loader-wrp");
    if (loader) loader.remove();
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    try {
      showLoader();

      const formData = new FormData(form.current);

      formData.append("access_key", "43724a9f-7d6d-4af0-8b23-c377deb489b5");
      formData.append("subject", "New Contact Form Submission");

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      hideLoader();

      if (result.success) {

        // ✅ NICE THANK YOU MESSAGE (UPDATED)
        Swal.fire({
          title: "Thank You 🎉",
          text: "Your message has been received. Our team will contact you shortly.",
          icon: "success",
          confirmButtonText: "OK"
        });

        form.current.reset();

      } else {
        throw new Error(result.message);
      }

    } catch (error) {
      console.error("Web3Forms Error:", error);

      hideLoader();

      Swal.fire({
        title: "Error",
        text: error.message || "Failed to send message. Please try again.",
        icon: "error",
      });
    }
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <div className="contact-form-sec">
        <div className="container">

          <div className="row">
            <div className="col-md-6">
              <input type="text" name="your_name" placeholder="Your Name" required />
              <input type="text" name="company_name" placeholder="Company Name" required />
            </div>

            <div className="col-md-6">
              <input type="email" name="email" placeholder="E-mail" required />
              <input type="tel" name="phone_number" placeholder="Phone Number" required />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <textarea name="message" placeholder="Your Message" required />

              <label>Budget</label>
              <input type="number" name="budget" required />

              <label>Timeline</label>
              <input type="date" name="due_date" required />

              <div className="form-btn-wrp">
                <button type="submit">Send Message</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
  );
};

export default Form;
 
